// The video editor's shell strings (components/Editor), under t('editor.rve.shell.<key>').
// Same keys in en, es, pt and ar; Arabic follows ../../ARABIC_STYLE.md.
export default {
  topBar: {
    unsavedChanges: 'Cambios sin guardar',
    savesToAccountHint: 'Los cambios se guardan en tu cuenta mientras trabajas',
    savesAutomatically: 'Se guarda solo',
    justNow: 'justo ahora',
    pendingHint: 'No pudimos conectar con tu cuenta, así que esto está guardado en este navegador; seguimos intentando.',
    deviceHint: 'No pudimos conectar con tu cuenta al abrir esto, así que los cambios quedan en este navegador. Vuelve a abrir la página para guardarlos en tu cuenta.',
    savedOnDevice: 'Guardado en este dispositivo {when}',
    savedToAccount: 'Guardado en tu cuenta',
    saved: 'Guardado',
    savedWhen: 'Guardado {when}',
    backToProject: 'Volver al proyecto',
    projectName: 'Nombre del proyecto',
    rename: 'Cambiar nombre',
    undo: 'Deshacer',
    redo: 'Rehacer',
    videoFormat: 'Formato del video',
    format: 'Formato',
    keyboardShortcuts: 'Atajos de teclado',
    watermarkHint: 'Las exportaciones del plan gratis llevan una pequeña marca de agua',
    removeWatermark: 'Quitar marca de agua',
    exporting: 'Exportando {progress}%',
    export: 'Exportar',
  },
  formats: {
    vertical: { label: 'Vertical', hint: 'TikTok, Reels, Shorts' },
    square: { label: 'Cuadrado', hint: 'Publicaciones del feed' },
    portrait: { label: 'Retrato', hint: 'Instagram, Facebook' },
    landscape: { label: 'Horizontal', hint: 'YouTube, web' },
  },
  exportDialog: {
    title: 'Exportar video',
    description: 'Un MP4 hecho con todo lo que hay en la línea de tiempo.',
    format: 'Formato',
    size: 'Tamaño',
    length: 'Duración',
    ready: 'Tu video está listo',
    download: 'Descargar',
    exportAgain: 'Exportar de nuevo',
    starting: 'Empezando…',
    rendering: 'Procesando',
    keepEditing: 'Puedes cerrar esto y seguir editando: la exportación continúa, y los cambios que hagas ahora no entran en ella.',
    failed: 'La exportación falló.',
    tryAgain: 'Intentar de nuevo',
    watermark: 'Las exportaciones del plan gratis llevan una pequeña marca de agua.',
    upgrade: 'Mejorar plan',
    tooLong: 'Las exportaciones pueden durar hasta 15 minutos, y este video dura {length}. Recórtalo en la línea de tiempo o en la transcripción y luego expórtalo.',
    addSomethingFirst: 'Primero agrega algo a la línea de tiempo',
    exportVideo: 'Exportar video',
    earlierExports: 'Exportaciones anteriores',
  },
  shortcuts: {
    title: 'Atajos de teclado',
    description: 'Funcionan en cualquier parte del editor, excepto mientras escribes en un campo.',
    playPause: 'Reproducir / pausar',
    frameStep: 'Retroceder / avanzar un fotograma',
    secondStep: 'Retroceder / avanzar un segundo',
    jumpEnds: 'Ir al inicio / al final',
    split: 'Dividir la capa seleccionada en el cabezal',
    delete: 'Eliminar la capa seleccionada',
    duplicate: 'Duplicar la capa seleccionada',
    undo: 'Deshacer',
    redo: 'Rehacer',
    saveNow: 'Guardar ahora',
    export: 'Exportar',
    deselect: 'Quitar selección',
    showShortcuts: 'Mostrar atajos',
  },
  inspector: {
    kinds: {
      text: 'Texto',
      video: 'Video',
      image: 'Imagen',
      audio: 'Audio',
      captions: 'Subtítulos',
      sticker: 'Sticker',
      progressBar: 'Barra de progreso',
    },
    noSettings: 'Esta capa no tiene ajustes.',
    format: 'Formato',
    background: 'Fondo',
    backgroundColor: 'Fondo {color}',
    customColour: 'Color personalizado',
    customBackground: 'Color de fondo personalizado',
    backgroundHint: 'Se ve donde ninguna capa cubre el lienzo.',
    safeZones: 'Zonas seguras',
    safeZonesHint: 'Sombrea donde TikTok, Reels y Shorts ponen sus botones y textos, para que nada importante quede debajo.',
    showSafeZones: 'Mostrar zonas seguras',
    summaryOne: '1 capa · dura {length}. Selecciona una capa en el lienzo o en la línea de tiempo para cambiarla.',
    summaryMany: '{n} capas · dura {length}. Selecciona una capa en el lienzo o en la línea de tiempo para cambiarla.',
    duplicateLayer: 'Duplicar capa',
    duplicate: 'Duplicar',
    deleteLayer: 'Eliminar capa',
    delete: 'Eliminar',
    thisVideo: 'Este video',
    hideProperties: 'Ocultar propiedades',
    properties: 'Propiedades',
  },
  library: {
    nav: 'Biblioteca',
    hidePanel: 'Ocultar panel',
    transcript: { label: 'Transcripción', title: 'Transcripción' },
    captions: { label: 'Subtítulos', title: 'Subtítulos' },
    text: { label: 'Texto', title: 'Texto' },
    uploads: { label: 'Subidas', title: 'Tus archivos' },
    stock: { label: 'Banco', title: 'Banco de videos' },
    images: { label: 'Imágenes', title: 'Imágenes' },
    audio: { label: 'Audio', title: 'Música y sonidos' },
    brand: { label: 'Marca', title: 'Kit de marca' },
    exports: { label: 'Exportados', title: 'Exportaciones' },
  },
  mobile: {
    nav: 'Editar',
    transcript: 'Transcripción',
    captions: 'Subtítulos',
    text: 'Texto',
    format: 'Formato',
    exports: 'Exportados',
  },
  brand: {
    logoUpdated: 'Logo actualizado',
    logoAdded: 'Logo agregado',
    captionStyleSaved: 'Estilo de subtítulos guardado',
    captionsRestyled: 'Subtítulos con el estilo nuevo',
    logo: 'Logo',
    upload: 'Subir',
    pngHint: "PNG, JPEG o WebP de hasta 2 MB. Un PNG con fondo transparente se ve mejor.",
    corner: 'Esquina',
    corners: {
      topLeft: 'arriba a la izquierda',
      topRight: 'arriba a la derecha',
      bottomLeft: 'abajo a la izquierda',
      bottomRight: 'abajo a la derecha',
    },
    size: 'Tamaño',
    opacity: 'Opacidad',
    updateLogo: 'Actualizar el logo en este video',
    addLogo: 'Agregar el logo a este video',
    captionStyle: 'Estilo de subtítulos',
    savedStyle: 'Guardado: subtítulos {font}.',
    customFont: 'personalizados',
    styleHint: 'Dale a los subtítulos de un video el estilo que te guste, guárdalo aquí y dale a cada video el mismo look.',
    saveCurrent: 'Guardar actual',
    applySaved: 'Aplicar guardado',
    accountHint: "Tu kit de marca es de tu cuenta: el mismo logo y estilo de subtítulos aquí, en el editor de clips y en cada clip que exportes.",
    replace: "Cambiar",
    remove: "Quitar el logo",
    failed: "No se pudo guardar. Inténtalo de nuevo.",
    tooBig: "Esa imagen pesa más de 2 MB.",
    notPicture: "Esa no es una imagen PNG, JPEG o WebP.",
  },
  editor: {
    restored: 'Seguimos donde lo dejaste: tus cambios de {ago}.',
    startOver: 'Empezar de nuevo desde el original',
    dismiss: 'Cerrar',
    opening: 'Abriendo tu proyecto…',
    properties: 'Propiedades',
  },
  stage: {
    frameError: 'No se pudo dibujar este fotograma',
    layerFailed: 'Una capa no se pudo cargar.',
    linkExpired: 'Puede que un enlace de medios haya caducado: al volver a abrir el proyecto se obtienen enlaces nuevos.',
    startWithVideo: 'Empieza con un video',
    startHint: 'Trae tu material y luego recórtalo, ponle subtítulos y agrega texto en la línea de tiempo de abajo.',
    uploadVideo: 'Subir un video',
    browseStock: 'Buscar videos de stock',
    addTitle: 'Agregar un título',
    startHintPhone: 'Trae tu material y luego recórtalo, ponle subtítulos y agrega texto desde las pestañas de abajo.',
  },
  timelineLabels: {
    text: 'Texto',
    image: 'Imagen',
    video: 'Video',
    audio: 'Audio',
    caption: 'Subtítulo',
    sticker: 'Sticker',
    progressBar: 'Barra de progreso',
    shape: 'Forma',
    item: 'Elemento',
  },
  renders: {
    countOne: '1 exportación',
    countMany: '{n} exportaciones',
    none: 'Aún no hay exportaciones',
    refresh: 'Actualizar',
    nothingYet: 'Todavía no exportaste nada',
    keptHere: 'Lo que exportas desde el editor se guarda aquí, listo para descargarlo de nuevo.',
    exportThis: 'Exportar este video',
    exporting: 'Exportando',
    video: 'Video',
    failed: 'La exportación falló',
    download: 'Descargar',
  },
  page: {
    opening: 'Abriendo tu proyecto…',
    openFailed: 'No se pudo abrir este proyecto.',
    clipFailed: 'No se pudo abrir este clip',
    projectFailed: 'No se pudo abrir este proyecto',
    goBack: 'Volver',
    seoTitle: 'Editor de video - Herramienta profesional de edición de video en línea',
    seoDescription:
      'Edita tus videos con nuestro potente editor de video en línea. Agrega subtítulos, capas, animaciones y efectos. Edición con línea de tiempo y vista previa en tiempo real. Ideal para crear contenido atractivo para redes sociales.',
  },
};
